import React,{Fragment} from 'react'
import { Button, Input } from '@mui/material';
import GetFilterDropdown, { filterOptions } from './GetFilterDropdown';
import CustomInput from '../../genericComponents/CustomInput';
const FilterValues = ({ column, compareIndex, onChange, value }) => {
    
    const inputValue = value.value;
    const inputValue2 = value.value2;
    if (column.dataType === "bool") {
        return <Fragment>
            <Button variant="contained" color={inputValue === true ? "primary" : "default"} fullWidth onClick={() => onChange({ value: true })}>{"i18n_filter_true"}</Button>
            <Button variant="contained" color={inputValue === false ? "primary" : "default"} fullWidth onClick={() => onChange({ value: false })}>{"i18n_filter_false"}</Button>
        </Fragment>
    }

    let filterType;
    if (column.dataType.startsWith("enum-")) {
        filterType = "enum"
    } else {
        const getFilter = GetFilterDropdown(column.dataType)[compareIndex]
        if (!getFilter) {
            filterType = 'string'
        } else {
            filterType = filterOptions.find(x => x.type === getFilter.type).type
        }
    }

    let type = "text";
    let inputType="String";
    switch (column.dataType) {
        case 'byte':
        case 'sbyte':
        case 'short':
        case 'ushort':
        case 'int':
        case 'uint':
        case 'long':
        case "Float":
        case 'ulong':
        case 'float':
        case 'double':
        case 'decimal': type = "number";inputType="Int"; break
        case 'Boolean': type='bool';inputType="Boolean"; break;
        case 'DateTime':type='date';inputType="Date"; break;
        default: type = "text";
    }
    switch (filterType) {
        case "between":
        case "nbetween":
        case "from":
        case "nfrom":
            return <Fragment>
                <CustomInput type={type} onChange={value => onChange({ ...value, value: value })} value={inputValue} />
                <CustomInput type={type} onChange={value => onChange({ ...value, value2: value })} value={inputValue2} />
            </Fragment>
        default: return <CustomInput placeholder={"Waarde"}  type={inputType} onChange={e =>{onChange({value:e})}} value={inputValue} />
    }
}
export default FilterValues;